import React, { useContext, useEffect, useRef, useState } from "react";
import { AppSettingContext } from "../../Application";

interface IChooseLoadAmountStepProps {
    cacheLoadAmount: number;
    handleSetLoadAmount(loadAmount: string, isValid: boolean): void;
    handleSetCurrentStep(): void;
}

const ChooseLoadAmountStep = (props: IChooseLoadAmountStepProps) => {
    const { labels, activateSettings } = useContext(AppSettingContext);

    const firstRender = useRef(true);

    //#region STATE PROPERTIES

    const [value, setValue] = useState(props.cacheLoadAmount?.toString() ?? "");
    const [isValueValid, setIsValueValid] = useState(true);

    //#endregion

    //#region USE EFFECT HOOKS

    useEffect(() => {
        if (firstRender.current && !props.cacheLoadAmount) {
            firstRender.current = false;
            return;
        }

        if (!value || value.includes('.') || value.includes('-')) {
            setIsValueValid(false);
            props.handleSetLoadAmount(value, false);
            return;
        }

        const intValue = parseInt(value);
        if (intValue < 1 || intValue > 5000) {
            setIsValueValid(false);
            props.handleSetLoadAmount(value, false);
            return;
        }

        setIsValueValid(true);
        props.handleSetLoadAmount(value, true);
    }, [value]);

    //#endregion

    //#region HANDLERS

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        props.handleSetCurrentStep();

        if (event.target.value.includes('.') || event.target.value.includes('-')) {
            event.preventDefault();
            return;
        }

        if (!event.target.value) {
            setValue("");
            return;
        }

        const newValue = Math.max(1, Math.min(activateSettings.loadMaxValue, Number(event.target.value)));
        setValue(newValue.toString());
    };

    //#endregion

    return (
        <div className="load-choose">
            <h4>{labels.get("GiftCard.App.ActivateLoadCard.Steps.ChooseAmount")}</h4>
            <div className="form-field currency">
                <label htmlFor="load-value" className="label-fs">
                    {labels.get("GiftCard.App.ActivateLoadCard.Labels.ChooseValue")}
                </label>
                <div className="flex-container">
                    <i>&euro;</i>
                    <input
                        type="number"
                        className={isValueValid ? "" : "react-input-error"}
                        value={value}
                        pattern="\d+"
                        onChange={(event) => handleChange(event)}
                        name="load-value"
                        id="load-value"
                        placeholder={labels.get("GiftCard.App.ActivateLoadCard.Placeholders.ChooseValue")}
                    />
                </div>
                <i className={!isValueValid ? "small-fs info error" : "small-fs info"}>
                    {labels.get("GiftCard.App.ActivateLoadCard.Tips.ChooseValue")}
                </i>
            </div>
        </div>
    );
};

export default ChooseLoadAmountStep;